/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { ScheduledBlock } from './ScheduledBlock';
import {
    ScheduledBlockFromJSON,
    ScheduledBlockFromJSONTyped,
    ScheduledBlockToJSON,
    ScheduledBlockToJSONTyped,
} from './ScheduledBlock';

/**
 * 
 * @export
 * @interface ScheduleGroup
 */
export interface ScheduleGroup {
    /**
     * 
     * @type {Array<ScheduledBlock>}
     * @memberof ScheduleGroup
     */
    scheduledBlocks: Array<ScheduledBlock>;
    /**
     * 
     * @type {number}
     * @memberof ScheduleGroup
     */
    totalDurationSeconds: number;
    /**
     * 
     * @type {OrderType}
     * @memberof ScheduleGroup
     */
    blocksOrderType: OrderType;
    /**
     * 
     * @type {number}
     * @memberof ScheduleGroup
     */
    variancePercentage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleGroup
     */
    useQueue?: boolean;
}



/**
 * Check if a given object implements the ScheduleGroup interface.
 */
export function instanceOfScheduleGroup(value: object): value is ScheduleGroup {
    if (!('scheduledBlocks' in value) || value['scheduledBlocks'] === undefined) return false;
    if (!('totalDurationSeconds' in value) || value['totalDurationSeconds'] === undefined) return false;
    if (!('blocksOrderType' in value) || value['blocksOrderType'] === undefined) return false;
    return true;
}

export function ScheduleGroupFromJSON(json: any): ScheduleGroup {
    return ScheduleGroupFromJSONTyped(json, false);
}

export function ScheduleGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'scheduledBlocks': ((json['scheduled_blocks'] as Array<any>).map(ScheduledBlockFromJSON)),
        'totalDurationSeconds': json['total_duration_seconds'],
        'blocksOrderType': OrderTypeFromJSON(json['blocks_order_type']),
        'variancePercentage': json['variance_percentage'] == null ? undefined : json['variance_percentage'],
        'useQueue': json['use_queue'] == null ? undefined : json['use_queue'],
    };
}

export function ScheduleGroupToJSON(json: any): ScheduleGroup {
    return ScheduleGroupToJSONTyped(json, false);
}

export function ScheduleGroupToJSONTyped(value?: ScheduleGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scheduled_blocks': ((value['scheduledBlocks'] as Array<any>).map(ScheduledBlockToJSON)),
        'total_duration_seconds': value['totalDurationSeconds'],
        'blocks_order_type': OrderTypeToJSON(value['blocksOrderType']),
        'variance_percentage': value['variancePercentage'],
        'use_queue': value['useQueue'],
    };
}

